import { RichText } from "@vinomofo/gatsby-types";

import { RichTextBlock } from "../components/rich-text-block";
import { richTextRenderer } from "../utils/rich-text-renderer";

const test = ({ __typename }: { __typename: string }): boolean =>
  __typename === "VinoData_RichTextBlock";

const create = (data: {
  heading?: string;
  subheading?: string;
  body: {
    [key: string]: any;
  };
}): JSX.Element => {
  const { heading, subheading, body } = data;

  const bodyTextJson = { json: JSON.parse(body.raw) };

  return (
    <RichTextBlock
      heading={heading}
      subheading={subheading}
      bodyText={richTextRenderer(bodyTextJson, {
        h3: { variant: "sm", color: "text.heading" },
      })}
    />
  );
};

export default { test, create };
